import { render, staticRenderFns } from "./pathology.vue?vue&type=template&id=7cfa45e3&scoped=true"
import script from "./pathology.vue?vue&type=script&lang=js"
export * from "./pathology.vue?vue&type=script&lang=js"
import style0 from "./pathology.vue?vue&type=style&index=0&id=7cfa45e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfa45e3",
  null
  
)

export default component.exports